var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconConsoleLogDebug = function SvgIconConsoleLogDebug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16302_33537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1258 5.89655L18.7692 8.60963L16.9609 9.85358",
    stroke: "#4CD266",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12.6793H6.71885",
    stroke: "#4CD266",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2812 12.6793H21.5001",
    stroke: "#4CD266",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.85156 5.89655L5.20811 8.60963L7.01638 9.85358",
    stroke: "#4CD266",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6037 19.462H11.3978C9.14996 19.462 7.32812 17.6402 7.32812 15.3924V11.3227C7.32812 9.82376 8.54223 8.60965 10.0412 8.60965H13.9603C15.4592 8.60965 16.6733 9.82376 16.6733 11.3227V15.3924C16.6733 17.6402 14.8515 19.462 12.6037 19.462Z",
    stroke: "#4CD266",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.85156 19.4619L5.20811 16.7489L7.01638 15.5049",
    stroke: "#4CD266",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1258 19.4619L18.7692 16.7489L16.9609 15.5049",
    stroke: "#4CD266",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.723 8.60964H9.29688V5.89655C9.29688 5.14774 9.90461 4.54001 10.6534 4.54001H13.3665C14.1153 4.54001 14.723 5.14774 14.723 5.89655V8.60964Z",
    stroke: "#4CD266",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16302_33537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export { SvgIconConsoleLogDebug as ReactComponent };
export default __webpack_public_path__ + "icon-console-log-debug.svg";